import React from 'react'
import Radio from '../../baseComponent/radio'
import './inspirationType.less'

export default ({ value, onChange }) => {
  return (<div className="inspiration-type">
    <Radio checked={value === 0} onChange={() => onChange(0)}>灵感集</Radio>
    <Radio checked={value === 1} onChange={() => onChange(1)} style={{ marginLeft: '80px' }}>灵感集PRO</Radio>
  </div>)
}
